import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppLayout from "./AppLayout/AppLayout";
import BuilderRoutes from "./BuilderRoutes/BuilderRoutes";
import CustomerRoutes from "./CustomerRoutes/CustomerRoutes";
import LandingRoutes from "./LandingRoutes/LandingRoutes";
import MasterDataPage from "../pages/MasterDataPage"; // Import the new page
import GoogleCallback from "../pages/GoogleCallback";
import AgentRoutes from "./AgentRoutes/AgentRoutes";
import VendorPurchasePage from "../layout/builders/ERP/VendorPurchasePage";
import ConsultantRoutes from "./ConsultantRoutes/ConsultantRoutes";


const Routing = () => {
  return (
    <BrowserRouter>
      <AppLayout>
        <Routes>
          {/* Add the Master Data route */}
          <Route path="/master-data/:projectId" element={<MasterDataPage />} />
          <Route path="/erp/vendor/:vendorId/purchase/:purchaseId?" element={<VendorPurchasePage />} />
          <Route path="/google/callback" element={<GoogleCallback />} />
          {/* Customer routes with /customer prefix */}
          <Route path="/customer/*" element={<CustomerRoutes />} />
          {/* Builder routes */}
          <Route path="/builder/*" element={<BuilderRoutes />} />
          {/* Agent routes */}
          <Route path="/agent/*" element={<AgentRoutes />} />
          {/* Consultant routes */}
          <Route path="/consultant/*" element={<ConsultantRoutes />} />
          {/* Landing routes - MUST be last as it uses wildcard */}
          <Route path="/*" element={<LandingRoutes />} />
        </Routes>
      </AppLayout>
    </BrowserRouter>
  );
};

export default Routing;
